import React, { type PropsWithChildren, useMemo } from 'react';

import {
	ProfileCardClientConfigContext,
	type ProfileCardClientConfigProviderState,
} from '@atlassian/people-teams-ui/profile-client-config';

import { useProfileClient } from '../index';

export function ProfileCardClientConfigProvider({
	children,
	...props
}: PropsWithChildren<Omit<ProfileCardClientConfigProviderState, 'profileCardClient'>>) {
	const profileCardClient = useProfileClient();

	const config = useMemo(
		() => ({
			...props,
			profileCardClient,
		}),
		[props, profileCardClient],
	);

	return (
		<ProfileCardClientConfigContext.Provider value={config}>
			{children}
		</ProfileCardClientConfigContext.Provider>
	);
}
